/**
 * Static config for the CwC "How our recipe boxes work" section. Copy is verified against Figma
 * (section 320:11785). The three video URLs are hosted on Contentstack and referenced by URL
 * (matching the Reviews Section's `RECIPE_VIDEOS` pattern — no live CMS query). The fourth step is a
 * static image (no `videoURL`/`tile`) carrying the decorative floating pills.
 *
 * Note: colocated here (not as `CWC_HOW_IT_WORKS` in the shared `config.tsx`) because that name is
 * already used by the pre-CwC `HowItWorksSection`'s `enableNewHowItWorksCopy` path.
 */
export type CWCHowItWorksVideoStep = {
  stepNumber: number
  title: string
  body: string
  videoURL: string
  tile: string
}

export type CWCHowItWorksStaticStep = {
  stepNumber: number
  title: string
  body: string
}

export type CWCHowItWorksStep = CWCHowItWorksVideoStep | CWCHowItWorksStaticStep

export const isVideoStep = (step: CWCHowItWorksStep): step is CWCHowItWorksVideoStep =>
  'videoURL' in step

export const CWC_HOW_IT_WORKS_SECTION: {
  heading: string
  steps: CWCHowItWorksStep[]
  cta: { label: string; href: string }
} = {
  heading: 'How our recipe boxes work',
  steps: [
    {
      stepNumber: 1,
      title: 'Build your box',
      body: 'Choose your box size (1 to 5 people) and your delivery day.',
      videoURL:
        'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt00fa09a0ad1f2c82/6a5f39028dec5a1f65f34142/build_your_box.mp4',
      tile: 'build_your_box',
    },
    {
      stepNumber: 2,
      title: 'Pick your recipes',
      body: 'Discover global cuisines and cater to every dietary need.',
      videoURL:
        'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/blt496141aa2d47d409/6a5f21bc8dec5a482ef34071/pick_your_recipes.mp4',
      tile: 'pick_your_recipes',
    },
    {
      stepNumber: 3,
      title: 'Let us do the hard work',
      body: 'Get pre-measured ingredients delivered to your door.',
      videoURL:
        'https://eu-assets.contentstack.com/v3/assets/blt249ad47e3410b9aa/bltc8054c0e0aa88bc6/6a5f39042c3e683fdb9303a3/let_us_do_the_hard_work.mp4',
      tile: 'let_us_do_the_hard_work',
    },
    {
      stepNumber: 4,
      title: 'Make changes whenever',
      body: 'Edit, skip or cancel your orders easily online at any time.',
    },
  ],
  cta: {
    label: 'More about how Gousto works',
    href: '/food-box/how-it-works',
  },
}
